import { C } from '@/integrations/whoop-theme';

/**
 * The chili glyph behind the recipes spice dial (Recipes.dc.html). Shared by the
 * detail modal's dial and the admin recipe form so the two render identically.
 */
export function PepperIcon({ filled }: { filled: boolean }) {
  const body = filled ? C.low : 'none';
  const stroke = filled ? C.low : 'rgba(255,255,255,0.24)';
  const stem = filled ? C.good : 'rgba(255,255,255,0.24)';
  return (
    <svg
      viewBox="0 0 24 24"
      width="22"
      height="22"
      fill="none"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12.5 4.5c0 1.4 -0.6 2.2 -1.6 2.8" stroke={stem} />
      <path
        d="M10.9 7.3c-4 0 -6.4 3.2 -5.6 7 0.6 2.8 3.2 4.9 6 4.6 3.8 -0.4 6.2 -4.4 5 -8.2 -0.6 -2 -2.6 -3.4 -4.6 -3.4 -0.3 0 -0.6 0 -0.8 0z"
        fill={body}
        stroke={stroke}
      />
    </svg>
  );
}
